import moment from 'moment';

export function getUniqueValue(buildings) {
  let array = [];
  for (let i = 0; i < buildings.length; i++) {
    let ind = array.findIndex(a => a.NOCIE === buildings[i].NOCIE && a.NODIV ===  buildings[i].NODIV);
    if (ind === -1) {
      let obj = {
        Id: buildings[i].IdBuilding ? buildings[i].IdBuilding : buildings[i].Id,
        NOCIE: buildings[i].NOCIE,
        NODIV: buildings[i].NODIV,
        NOMDIV: buildings[i].NOMDIV,
        Inclusions: buildings[i].Inclusions,
        OtherServices: buildings[i].OtherServices,
        Promotions: buildings[i].Promotions        
      }
      array.push(obj);
    }
  }
  return array;
}

export function mappBuildingDataForSelect(buildings) {
  let array = [];
  let unique = getUniqueValue(buildings);
  for (let i = 0; i < unique.length; i++) {
    let options = {};
    options.value = unique[i];
    options.text = unique[i].NOMDIV;
    array.push(options);
  }
  return array;
}

export function mappBuildingDataForAddress(buildings) {
  let array = [];
  for (let i = 0; i < buildings.length; i++) {
    let options = {};
    options.value = buildings[i];
    //if (buildings[i].BuildingInfo) {
      options.text = buildings[i].BuildingInfo.NOMDIV +" | "+buildings[i].BuildingInfo.Street+ " # "+buildings[i].UNITE;
    //}
    //else {
      //options.text = buildings[i].NOMDIV +" # "+buildings[i].UNITE;
  //  }

    array.push(options);
  }
  return array;
}

export function mappUnitDataForSelect(list) {
  let array = [];
  for (let i = 0; i < list.length; i++) {
    let options = {};
    options.value = list[i];
    options.text = list[i].NOMDIV.concat(" # "+list[i].UNITE);
    array.push(options);
  }

  return array;
}

export function formatSelectedValues(list, cat, lg) {
  let arr = [];
  for (let i = 0; i < list.length; i++) {
    if (list[i].cat === cat) {
      let obj = {};
      obj.text = list[i][lg];
      if (list[i].key === "title") {
        obj.value = null;
        arr.unshift(obj);
      }
      else {
        obj.value = list[i].key;
        arr.push(obj);
      }
    }
  }
  return arr;
}

export function formatType(list, lg) {
  let array = [];
  for (let i = 0; i < list.length; i++) {
    let options = {};
    options.value = list[i].Id;
    options.text = lg === 'fr' ? list[i].fr : list[i].en;
    array.push(options);
  }
  return array;
}

export function formatTypeWithStatus(list, lg) {
  let array = [];
  for (let i = 0; i < list.length; i++) {
    if (list[i].status === 1) {
      let options = {};
      options.value = list[i].Id;
      options.text = lg === 'fr' ? list[i].fr : list[i].en;
      array.push(options);
    }
  }
  return array;
}

export function formatAndTrim(list) {
  let array = [];
  for (let i = 0; i < list.length; i++) {
    if (list[i]) {
      let options = {};
      options.value = list[i];
      options.text = list[i].trim()
      array.push(options);
    }
  }

  return array;
}

export function formatDate(value) {
  let lastDayOfMOnth = moment().subtract(1, 'months').endOf('month').format("YYYY-MM-DD");
  let mydate = value ? moment(value.date).format('YYYY-MM-DD') : lastDayOfMOnth;
  
  return mydate;
}
